import b from 'b_';
import { ArrowShortBold } from 'education-icons';
import { Button, SimpleCallback } from 'platform-components/common';
import React from 'react';

import './calendar-plan-showcase__arrow-button.scss';

export enum ArrowButtonDirection {
    RIGHT = 'right',
    LEFT = 'left',
}

interface Props {
    onClick?: SimpleCallback;
    direction: ArrowButtonDirection;
}

export const ArrowButton = ({ direction, onClick }: Props) => (
    <Button
        className={b('calendar-plan-showcase', 'arrow-button', { direction })}
        icon={<ArrowShortBold />}
        onClick={onClick}
        rounded
        size={Button.SIZE.L}
        view={Button.VIEW.RAISED}
    />
);

ArrowButton.DIRECTION = ArrowButtonDirection;
